import React, { useRef, useState } from "react";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import { DateRangePicker } from "react-dates";
import { Row } from "../Layout";
import NTMButton from "../Buttons/NTMButton";
import NTMSelect from "components/Buttons/NTMSelect";

export default function IntervalBar({
	devices, device, setDevice,
	showDaily = true, showWeekly = true, showMonthly = true, showInterval = true,
	interval, setInterval: setIntvl, startDate, setStartDate, endDate, setEndDate,
	forecastEn, setForecastEn, showForecastBtn,
}) {

	let [focusedInput, setFocusedInput] = useState();
	let buttonRef = useRef();
	if(devices.length === 0) return <div/>
	if(!device) {
		setDevice(devices[0].device)
	}

	return (
			<Row>
				<NTMSelect value={device} onChange={event => setDevice(event.target.value)}>
					{devices.map(d =>
						<option key={d.device} value={d.device}>{d.label || d.device}</option>
					)}
				</NTMSelect>
				{showDaily && <NTMButton
					primary={interval === "daily"}
					unselected={interval !== "daily" ? 'true' : undefined}
					onClick={() => setIntvl("daily")}
				>Oggi</NTMButton>}
				{showWeekly && <NTMButton
					primary={interval === "weekly"}
					unselected={interval !== "weekly" ? 'true' : undefined}
					onClick={() => setIntvl("weekly")}
				>Ultimi 7 gg</NTMButton>}
				{showMonthly && <NTMButton
					primary={interval === "monthly"}
					unselected={interval !== "monthly" ? 'true' : undefined}
					onClick={() => setIntvl("monthly")}
				>Ultimi 30 gg</NTMButton>}
				{showInterval && <div data-tip data-for='global' data-event='click' ref={buttonRef}>
					<NTMButton
						primary={interval === "custom"}
						unselected={interval !== "custom" ? 'true' : undefined}
					>
						{
							startDate ?
								`${moment(startDate).format("DD/MM/YYYY")}
											-
											${moment(endDate).format("DD/MM/YYYY")}`
							: <>Scegli Periodo&nbsp;<i className="fa fa-caret-down" aria-hidden="true" /></>
						}
					</NTMButton>
				</div>}
				<ReactTooltip
					id='global'
					aria-haspopup='true'
					effect='solid'
					place={"bottom"}
					clickable
					getContent={() => <DateRangePicker
						startDate={startDate} // momentPropTypes.momentObj or null,
						startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
						endDate={endDate} // momentPropTypes.momentObj or null,
						endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
						onDatesChange={({startDate, endDate}) => {
							if (startDate !== null && endDate !== null) {
								buttonRef.current.click();
							}
							setIntvl("custom")
							setStartDate(startDate)
							setEndDate(endDate)
						}} // PropTypes.func.isRequired,
						focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
						onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
						withPortal={true}

						startDatePlaceholderText={"Inizio"}
						endDatePlaceholderText={"Fine"}
						displayFormat={"DD/MM/YYYY"}
						isOutsideRange={(o) => o.isAfter(moment(), 'day')}
						small={true}
					/>}
				/>
				{showForecastBtn && <NTMButton
					primary={forecastEn === true}
					unselected={forecastEn !== true ? 'true' : undefined}
					onClick={() => setForecastEn(en => !en)}
				>Previsioni meteo</NTMButton>}
			</Row>
	);
}
